import { Directive, Input } from '@angular/core';

import { Participant } from '@cds/betting-offer';
import { values } from 'lodash-es';

import { BaseOptionRendererDirective } from './base-option-renderer.directive';

type ParticipantFixture = {
    participants: Participant[];
};

@Directive({
    selector: '[msParticipantOptionRenderer]',
})
export class ParticipantOptionRendererDirective extends BaseOptionRendererDirective {
    @Input() fixture: ParticipantFixture;

    protected getColumnsSettings(): { maxColumns: number; oddColumns: boolean } {
        const participantOptions = this.fixture.participants;
        const grouped = values(participantOptions);

        let maxColumns = 3;
        let oddColumns = false;

        // always so maximum two columns and also fallback
        // for option groups with 4 options
        if (this.fixture.participants.length === 4) {
            maxColumns = 2;
        }

        // for option groups containing 3 options like double change or 3 way result
        // we always display them in single or triple column
        oddColumns = grouped.length === 1;

        return { maxColumns, oddColumns };
    }
}
